import React, { useState, useEffect } from 'react'
import {
  Container,
  Paper,
  Box,
  Typography,
  Tabs,
  Tab
} from '@mui/material'
import { useParams, useNavigate } from 'react-router-dom'
import CodingForm from '../components/mrd/MedicalCoding/CodingForm'
import CodingList from '../components/mrd/MedicalCoding/CodingList'
import ICDSearch from '../components/mrd/MedicalCoding/ICDSearch'
import DRGCalculator from '../components/mrd/MedicalCoding/DRGCalculator'
import CodingDashboard from '../components/mrd/MedicalCoding/CodingDashboard'
import CodingStats from '../components/mrd/MedicalCoding/CodingStats'

export const MedicalCodingPage = () => {
  const { fileId } = useParams()
  const navigate = useNavigate()
  
  const [tabValue, setTabValue] = useState(0)
  
  // Determine if we're in edit mode based on URL
  const isEditMode = window.location.pathname.includes('/edit')
  const isViewMode = fileId && !isEditMode

  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={600} gutterBottom>
          Medical Coding
        </Typography>
        <Typography variant="body1" color="text.secondary">
          ICD-10/ICD-11 Coding and DRG Assignment
        </Typography>
      </Box>

      {fileId ? (
        <CodingForm 
          fileId={fileId} 
          mode={isEditMode ? 'edit' : 'view'}
          onBack={() => navigate('/hospital/mrd/coding')} 
        />
      ) : (
        <>
          <Paper sx={{ mb: 3 }}>
            <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
              <Tab label="Dashboard" />
              <Tab label="Coding List" />
              <Tab label="ICD Search" />
              <Tab label="DRG Calculator" />
              <Tab label="Statistics" />
            </Tabs>
          </Paper>

          {tabValue === 0 && <CodingDashboard />}
          
          {tabValue === 1 && (
            <Paper sx={{ p: 3 }}>
              <CodingList 
                onEdit={(coding) => navigate(`/hospital/mrd/coding/${coding.mrdFile._id}/edit`)}
                onView={(coding) => navigate(`/hospital/mrd/coding/${coding.mrdFile._id}`)}
              />
            </Paper>
          )}

          {tabValue === 2 && (
            <Paper sx={{ p: 3 }}>
              <ICDSearch />
            </Paper>
          )}

          {tabValue === 3 && (
            <Paper sx={{ p: 3 }}>
              <DRGCalculator />
            </Paper>
          )}

          {tabValue === 4 && (
            <Paper sx={{ p: 3 }}>
              <CodingStats />
            </Paper>
          )}
        </>
      )}
    </Container>
  )
}

export default MedicalCodingPage